import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import LoadingModal from '../modals/LoadingModal';
import Pagination from '../Pagination';
import { useNavigate } from 'react-router-dom';
import { formatCNPJ } from '../../utils/cnpjUtils';
import { formatCPF } from '../../utils/cpfUtils';

const ModalFavorecidoFind = ({ show, onClose, onItemSelect }) => {
  const [Item, setItem] = useState({ descricao: '' });
  const [fornecedores, setFornecedores] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [startIndex, setStartIndex] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [busca, setBusca] = useState(''); // Novo estado para a busca
  const token = localStorage.getItem('token');
  const cnpj = localStorage.getItem('cnpj');
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API_BASE_URL.FAVORECIDO}/all`, {
        params: { cnpjAssociacao: cnpj },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(result => {
        setFornecedores(result.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Erro ao obter listas:', error);
        setLoading(false);
        navigate('/');
      });
  }, [cnpj, token, navigate]);

  const handleRowClick = p => {
    onItemSelect(p);
    onClose();
  };

  // Função para filtrar os fabricantes com base na busca
  const normalizeString = str => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
  };

  // Modifique a função de filtro para usar a normalização
  const fornecedoresFiltrados = fornecedores.filter(f => {
    const normalizedBusca = normalizeString(busca);
    return (
      normalizeString(f.nome).includes(normalizedBusca) ||
      normalizeString(f.cpfOrCnpj || '').includes(normalizedBusca) ||
      normalizeString(f.tipo || '').includes(normalizedBusca)
    );
  });

  const totalItems = fornecedoresFiltrados.length;
  const endIndex = startIndex + rowsPerPage;
  const selectedItens = fornecedoresFiltrados.slice(startIndex, endIndex);

  return (
    <div
      className={`modal fade ${show ? 'show d-block' : ''}`}
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
    >
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title text-danger text-shadow">
              PESQUISAR FORNECEDOR
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            {/* Campo de busca */}
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Digite para buscar..."
                value={busca}
                onChange={e => setBusca(e.target.value.toUpperCase())} // Atualiza o texto da busca
              />
            </div>
            <LoadingModal loading={isLoading} />
            <div
              className="table-responsive-sm mt-4 shadow-sm small"
              style={{ height: '300px', overflowY: 'auto' }}
            >
              <table className="table table-hover table-striped table-sm">
                <thead className="table-secondary sticky-top bg-light">
                  <tr>
                    <th style={{ width: '15%' }}>CPF/CNPJ</th>
                    <th style={{ width: '10%' }}>Tipo</th>
                    <th>Nome</th>
                  </tr>
                </thead>
                <tbody>
                  {!isLoading &&
                    selectedItens.map(i => (
                      <tr
                        key={`${i.cnpjAssociacao} - ${i.cpfOrCnpj}`}
                        onClick={() => handleRowClick(i)}
                        style={{ cursor: 'pointer' }}
                      >
                        <td style={{ width: '15%' }}>
                          {i.tipo === 'PF'
                            ? formatCPF(i.cpfOrCnpj)
                            : formatCNPJ(i.cpfOrCnpj)}
                        </td>
                        <td style={{ width: '10%' }}>
                          <span
                            className={`badge ${
                              i.tipo === 'PF' ? 'bg-info' : 'bg-success'
                            }`}
                          >
                            {i.tipo === 'PF'
                              ? 'Pessoa Física'
                              : 'Pessoa Jurídica'}
                          </span>
                        </td>
                        <td>{i.nome}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
          <Pagination
            totalItems={totalItems}
            rowsPerPage={rowsPerPage}
            startIndex={startIndex}
            onRowsPerPageChange={e => setRowsPerPage(Number(e.target.value))}
            onFirstItems={() => setStartIndex(0)}
            onPreviousItems={() =>
              setStartIndex(Math.max(startIndex - rowsPerPage, 0))
            }
            onNextItems={() =>
              setStartIndex(
                Math.min(startIndex + rowsPerPage, totalItems - rowsPerPage)
              )
            }
            onLastItems={() =>
              setStartIndex(Math.max(totalItems - rowsPerPage, 0))
            }
          />
        </div>
      </div>
    </div>
  );
};

export default ModalFavorecidoFind;
